import { useTranslation } from "react-i18next";

import { Button, Modal } from "semantic-ui-react";

const AssignIdea = ({ isOpen, onClose, assignIdea, loading }) => {
  const { t } = useTranslation();

  return (
    <Modal
      mountNode={document.getElementById("semantic-modal-mount-node")}
      open={isOpen}
      onClose={onClose}
    >
      <Modal.Header>Assign {t("generic.idea")} to your account?</Modal.Header>
      <Modal.Content>
        Assigning this {t("generic.idea")} to your account will allow you to
        return to it later to continue editing, as well as reply to comments.
      </Modal.Content>

      <Modal.Actions>
        <Button content="Cancel" onClick={onClose} />
        <Button
          primary
          content="Assign"
          loading={loading}
          icon="add user"
          onClick={assignIdea}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default AssignIdea;
